import React from 'react';

export const AddCardIcon = () => (
  <svg
    width="34px"
    height="25px"
    viewBox="0 0 34 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 5</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="resumen-productos-tarjetas-large"
        transform="translate(-66.000000, -495.000000)"
      >
        <g id="Group-5" transform="translate(66.000000, 490.000000)">
          <g id="Icon-/-Illustrative-/-Credit-Card-/-30px">
            <g
              id="Icon-/-Illustrative-/-Credit-Card-/-72px"
              transform="translate(0.000000, 5.000000)"
            >
              <g id="Group-7" transform="translate(0.625000, 0.625000)">
                <g id="Credit-Card" stroke="#7462E0" strokeWidth="1.5">
                  <path
                    d="M1.91666667,0.749936049 C1.27233446,0.749936049 0.75,1.27227051 0.75,1.91660272 L0.75,16.8333333 C0.75,17.4776655 1.27233446,18 1.91666667,18 L26.8333333,18 C27.4776655,18 28,17.4776655 28,16.8333333 L28,1.91660272 C28,1.27227051 27.4776655,0.749936049 26.8333333,0.749936049 L1.91666667,0.749936049 Z"
                    id="Rectangle-6"
                  />
                </g>
                <g
                  id="Group-411"
                  transform="translate(0.000000, 4.233871)"
                  strokeWidth="1.5"
                >
                  <path
                    d="M0.75,3.28225806 L28,3.28225806 L28,0.75 L0.75,0.75 L0.75,3.28225806 Z"
                    id="Stroke-4"
                    stroke="#7462E0"
                  />
                  <path
                    d="M4.025,8.640553 L8.625,8.640553"
                    id="Stroke-409"
                    stroke="#D1402C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.025,10.9447005 L12.3583333,10.9447005"
                    id="Stroke-410"
                    stroke="#D1402C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <g id="Group-10" transform="translate(19.765625, 10.887097)" />
              </g>
            </g>
          </g>
          <g id="Group-4" transform="translate(19.000000, 15.000000)">
            <circle id="Oval" fill="#FFFFFF" cx="7.5" cy="7.5" r="7.5" />
            <g
              id="Group-60"
              transform="translate(2.000000, 2.000000)"
              stroke="#042F43"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            >
              <path
                d="M-8.8817842e-15,5.25346236 C-8.8817842e-15,2.35250044 2.35250044,-2.29949393e-12 5.25346236,-2.29949393e-12 
                C8.15442427,-2.29949393e-12 10.5069247,2.35250044 10.5069247,5.25346236 C10.5069247,8.15442427 8.15442427,10.5069247 5.25346236,10.5069247 
                C2.35250044,10.5069247 -8.8817842e-15,8.15442427 -8.8817842e-15,5.25346236 L-8.8817842e-15,5.25346236 Z"
                id="Stroke-281"
              />
              <path
                d="M3.06451971,5.25346236 L7.2964755,5.25346236"
                id="Stroke-283"
              />
              <path
                d="M5.25346236,3.06451971 L5.25346236,7.2964755"
                id="Stroke-285"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
